import React from 'react';
import { Grid, Grid2, useMediaQuery } from '@mui/material';
import Header from '../componen/kasir/Header';
import KasirBranchRouter from '../componen/kasir/KasirBranchRouter';

const OrderBranch = ({userUuid}) => {
  const isMobile = useMediaQuery('(max-width:768px)'); 

  return (
   <>
      <Grid container>
      
        {!isMobile && (
          <>
            
            <Grid item xs={12}>
              <KasirBranchRouter userUuid={userUuid} />
            </Grid>
           
          </>
        )}
       
        {isMobile && (
          <>
            <Grid item xs={12}>
              <KasirBranchRouter userUuid={userUuid} />
            </Grid>
         
          </>
        )}
      </Grid>
      </>
  );
};

export default OrderBranch;
